// extracted by mini-css-extract-plugin
module.exports = {"img-container":"Tile_img-container__o2ru2","image":"Tile_image__TnrPL","text-container":"Tile_text-container__GC3eT","text":"Tile_text__9Em7a","tile":"Tile_tile__ga3Vl"};